// extracted by mini-css-extract-plugin
export default {"Spacing":"LabelWithIcon_Spacing__JID+J"};